<template>
  <div class="tooltip-wrapper" :class="{'normal ml-3': type === 'normal', 'hamburger' : type === 'hamburger'}">
    <span class="tooltip-text" :style="fontStyle">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "ToolTip",
  props: {
    label: String,
    type: {
      type: String,
      default: "normal"
    },
    fontStyle: String,
  }
}
</script>

<style scoped lang="scss">
.tooltip-wrapper {
  display: flex;
  background-color: white;
  position: relative;
}
.normal {
  padding: 4px 16px;
  border-radius: 3px;
  box-shadow: 1px 2px 5px rgba(90,85,85,0.7);
  .tooltip-text {
    color: $primary-color;
    font-size: $font-base10;
  }
}
.normal:before {
  left: calc((100% - 15px)/2);
  border-width: 6px 10px 0 0;
  bottom: -6px;
  border-color: white transparent transparent transparent;
  filter: drop-shadow(3px 3px 2px rgba(90,85,85,0.7));
}
.hamburger {
  padding: 2px 24px;
  border-radius: 4px;
  background-color: $primary-color;
  width: fit-content;
  line-height: 15px;
  .tooltip-text {
    color: white;
    font-size: 8px;
    text-align: center;
  }
}
.hamburger:before {
  left: calc((100% - 15px)/2);
  border-width: 6px 9px 0 0;
  border-color: $primary-color transparent transparent transparent;
  bottom: -6px;
}
.tooltip-wrapper:before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

</style>